import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { Location } from "../models/Location/Location";

export class LocationsRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getLocations = this.getLocations.bind(this);
		this.getLocationById = this.getLocationById.bind(this);
		this.createLocation = this.createLocation.bind(this);
		this.updateLocation = this.updateLocation.bind(this);
		this.deleteLocation = this.deleteLocation.bind(this);
	}

	async getLocations() {
		try {
			const locations = await this.axios.get("/Location/");

			return {
				ok: true,
				locations: locations.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getLocationById(locationId: number | null) {
		try {
			const location = await this.axios.get(`/Location/${locationId}`);
			return {
				ok: true,
				location: location.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}

	async createLocation({
		locationId,
		locationName,
		rootTypeId,
		isActive,
		locationTypeId,
		sortOrder,
	}: Location) {
		try {
			await this.axios.post("/Location/", {
				locationId,
				locationName,
				rootTypeId: rootTypeId || 3,
				isActive,
				locationTypeId: locationTypeId == 0 ? 5 : locationTypeId,
				sortOrder,
			});

			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async updateLocation(locationId: number | null, locationData: Location) {
		try {
			await this.axios.patch(`/Location/${locationId}`, locationData);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async deleteLocation(locationId: number | null) {
		try {
			await this.axios.delete(`/Location/`, {
				params: { locationId },
			});
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const {
	getLocations,
	getLocationById,
	createLocation,
	updateLocation,
	deleteLocation,
} = new LocationsRepository();
